























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { ProductsApi, Product, Job, TransceiversApi } from '@/api';
import TransceiverSuggest from '@/components/form pickers/transceiverSuggest.vue';
import SensorSuggest from '@/components/form pickers/sensorSuggest.vue';
import ChartAdmin from '@/components/charts/chart-admin.vue';
import Toast from '@/components/display/toast.vue';
import vue2Dropzone from 'vue2-dropzone';

@Component({
	components: {
		secondaryNav,
		TransceiverSuggest,
		ChartAdmin,
		Toast,
		vue2Dropzone,
		SensorSuggest,
	},
	validations: {
		vats: {
			$each: {
				transceiver: { id: { required }, serialNumber: { required } },
				stirrerSensor: { id: { required }, serialNumber: { required } },
				volumeSensor: { id: { required }, serialNumber: { required } },
				vatTempSensor: { id: { required }, serialNumber: { required } },
				inletTempSensor: { id: { required }, serialNumber: { required } },
				formula: { required },
				sizeString: { required },
			},
		},
	},
	mixins: [validationMixin],
})
export default class SensorAssignment extends Vue {
	public $bvToast: any;
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public vats = [];
	public job: Job | null = null;
	public product: Product | null = null;
	public rawData: any[] | null = [];

	public optionSizes = {
		FonterraVatII: [
			{ value: '2000', text: '2000' },
			{ value: '2300', text: '2300' },
			{ value: '3400', text: '3400' },
			{ value: '4100', text: '4100' },
			{ value: '4500', text: '4500' },
			{ value: '5700', text: '5700' },
			{ value: '6800', text: '6800' },
			{ value: '7800', text: '7800' },
			{ value: '9100', text: '9100' },
			{ value: '11000', text: '11000' },
			{ value: '11500W', text: '11500W' },
			{ value: '12000', text: '12000' },
			{ value: '14000', text: '14000' },
			{ value: '14000W', text: '14000W' },
			{ value: '15000', text: '15000' },
			{ value: '16000', text: '16000' },
			{ value: '16000W', text: '16000W' },
			{ value: '18000', text: '18000' },
			{ value: '18000W', text: '18000W' },
			{ value: '21500W', text: '21500W' },
			{ value: '24500W', text: '24500W' },
			{ value: '26500W', text: '26500W' },
			{ value: '30000W', text: '30000W' },
		],
		Butterfly: [
			{ value: '1050', text: '1050' },
			{ value: '1700', text: '1700' },
			{ value: '2250', text: '2250' },
			{ value: '2700', text: '2700' },
			{ value: '2700Cummings', text: '2700 Cummings' },
			{ value: '3400', text: '3400' },
			{ value: '3400Winiata', text: '3400 Winiata' },
			{ value: '3400KMOrganics', text: '3400 KM Organics' },
			{ value: '3700', text: '3700' },
			{ value: '3700DargavilleOrganics', text: '3700 Dargaville Organics' },
			{ value: '4100', text: '4100' },
			{ value: '4500', text: '4500' },
			{ value: '4500TawaRidge', text: '4500 Tawa Ridge' },
			{ value: '5700', text: '5700' },
			{ value: '6800', text: '6800' },
			{ value: '9100', text: '9100' },
		],
		Longveld: [
			{ value: '5400', text: '5400' },
			{ value: '7500', text: '7500' },
			{ value: '9400', text: '9400' },
			{ value: '11400', text: '11400' },
			{ value: '21000', text: '21000' },
			{ value: '29000', text: '29000' },
		],
		Spherical: [
			{ value: '10000', text: '10000' },
			{ value: '14000', text: '14000' },
			{ value: '24500', text: '24500' },
			{ value: '31000', text: '31000' },
		],
		Crown: [{ value: '22000', text: '22000' }],
	};
	public options = [
		{ value: 'FonterraVatII', text: 'Fonterra Vat II' },
		{ value: 'Butterfly', text: 'Butterfly' },
		{ value: 'Longveld', text: 'Longveld' },
		{ value: 'Spherical', text: 'Spherical' },
		{ value: 'Crown', text: 'Crown' },
	];

	public status = [
		{ value: 'complete', text: 'Completed' },
		{ value: 'failed', text: 'Not Completed' },
	];

	public token = this.$auth.token();

	public dropzoneOptions = {
		url: process.env.VUE_APP_API_URL + '/vats/uploadImage',
		thumbnailWidth: 150,
		maxFilesize: 7.0,
		headers: {
			'Cache-Control': null,
			'X-Requested-With': null,
			Authorization: 'Bearer ' + this.$auth.token(),
		},
	};

	public awsDropzoneOptions = {
		url: process.env.VUE_APP_API_URL + '/vats/s3/awsUpload', // call after AWS upload
		thumbnailWidth: 150,
		maxFilesize: 7.0,
		parallelUploads: 1,
		sendFileToServer: false,
		method: 'POST',
		headers: {
			'Cache-Control': null,
			'X-Requested-With': null,
			Authorization: 'Bearer ' + this.$auth.token(),
		}, //
	};

	public awsOptions = {
		// signingURL: (f) =>process.env.VUE_APP_API_URL + '/vats/sign/signature', // needs to be correct format
		signingURL: process.env.VUE_APP_API_URL + '/vats/sign/signature', // needs to be correct format
		headers: {},
		params: {},
		sendFileToServer: true,
		withCredentials: false,
		headers: { Authorization: 'Bearer ' + this.$auth.token() },
	};

	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
	}

	public isValid(field) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	// public sensors: any[] | null = [];
	public vatSelect() {
		this.form.vat2transceiver = this.form.transceiver;
		this.form.vat3transceiver = this.form.transceiver;
	}

	public sendingEvent(file, xhr, formData) {
		formData.append('vatId', this.vats[0].id);
	}

	public sendingVat2Event(file, xhr, formData) {
		formData.append('vatId', this.vats[1].id);
	}

	public sendingVat3Event(file, xhr, formData) {
		formData.append('vatId', this.vats[2].id);
	}

	public s3UploadError(error) {
		console.log(error);
	}

	public s3UploadSuccess(location) {
		console.log(location);
	}

	public async getRawData() {
		this.rawData = [];
		for (const vat of this.vats) {
			const api = new TransceiversApi();
			if (vat.transceiver) {
				const response = await api.getTransceiverData(parseInt(vat.transceiver.id, 10));
				this.rawData.push({
					serialNumber: vat.transceiver.serialNumber,
					rawData: response.data.data,
				});
			}
		}
	}

	public stepValidate(name: string) {
		return async () => {
			const form = this.$v[name];
			form.$touch();
			return !form.$invalid;
		};
	}

	public async onComplete(...a: any[]) {
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const { productId } = this.$route.params;
		const product: Product = {};
		product.vats = this.vats.map(vat => ({
			vatId: vat.id,
			vatType: vat.formula,
			vatSize: vat.sizeString,
			transceiverId: vat.transceiver.id,
		}));
		product.vatSensors = [];
		this.vats.map(vat => {
			product.vatSensors.push(
				{
					sensorId: vat.stirrerSensor.id,
					sensorType: 'stirrer',
					vatId: vat.id,
					transceiverId: vat.transceiver.id,
				},
				{
					sensorId: vat.volumeSensor.id,
					sensorType: vat.volumeSensor.type ?? 'lidarDistance',
					vatId: vat.id,
					transceiverId: vat.transceiver.id,
				},
				{
					sensorId: vat.vatTempSensor.id,
					sensorType: 'vatTemp',
					vatId: vat.id,
					transceiverId: vat.transceiver.id,
				},
				{
					sensorId: vat.inletTempSensor.id,
					sensorType: 'inletTemp',
					vatId: vat.id,
					transceiverId: vat.transceiver.id,
				},
			);
		});
		product.transceivers = [];
		this.vats.map(vat => {
			if (!product.transceivers.some(transceiver => transceiver.id === vat.transceiver.id)) {
				product.transceivers.push({ id: vat.transceiver.id });
			}
		});

		try {
			// response = await new JobsApi().processJob(parseInt(jobId, 10), {data: job});
			const response = await new ProductsApi().productAssignSensors(parseInt(productId, 10), {
				data: product,
			});
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Allocating Sensors', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
		new Toast().makeToast('Successfully Allocated Sensors', 'Successful Allocation', 'success');
		setTimeout(() => {
			this.submitStatus = 'OK';
			this.$router.push({ name: 'products.milk.view', params: { productId } });
		}, 1000);
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
	}

	public async load() {
		try {
			const { productId } = this.$route.params;
			this.loading = true;

			const { data } = await this.api.getProductById(parseInt(productId, 10), {
				params: {
					include: 'vats,org,vats.transceiver.site,vats.sensors.transceiver.site', // ,transceivers,sensors
				},
			});
			this.product = data;
			this.vats = data.vats || [];
			this.transceivers = data.transceivers || {};
			this.vats.map(vat => {
				(vat.volumeSensor = vat.sensors.find(
					x => x.type === 'lidarDistance' || x.type === 'radarDistance',
				)),
					(vat.vatTempSensor = vat.sensors.find(x => x.type === 'vatTemp')),
					(vat.inletTempSensor = vat.sensors.find(x => x.type === 'inletTemp')),
					(vat.stirrerSensor = vat.sensors.find(x => x.type === 'stirrer'));
			});
		} catch (e) {
			this.job = null;
		} finally {
			this.loading = false;
		}
	}
	public created() {
		this.load();
	}
}
